import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import RegistrationPage from './RegistrationPage';

// Apply saved theme asap to avoid flash of wrong theme on pages rendered outside of App
try {
  const saved = localStorage.getItem('theme');
  const theme = saved || (window.matchMedia && window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light');
  document.documentElement.setAttribute('data-theme', theme);
  if (!saved) localStorage.setItem('theme', theme);
} catch (e) {
  // ignore
}

const root = ReactDOM.createRoot(document.getElementById('root'));
const path = typeof window !== 'undefined' ? window.location.pathname.replace(/\/+$/, '') : '';
const isRegistration = path === '/registration';

root.render(
  <React.StrictMode>
    {isRegistration ? <RegistrationPage /> : <App />}
  </React.StrictMode>
);

